const sign = {
  path: 'sign/:signatureKey',
  props: true,
  component: resolve => require(['../../../pages/plat/sign'], resolve)
}

export default sign
